@if (loading) {
  <div class="container">
    <div class="body-container body-container--min-height">
      <app-loading-component></app-loading-component>
    </div>
  </div>
}
<div class="container">
  <div class="body-container body-container--min-height">
     <info-modal info-modal
      [visible]="info_modal_visible"
      [title]="info_modal_title"
      [message]="info_modal_message"
      [confirmText]="info_modal_button_text"
      (onConfirm)="onConfirmModal()">
      </info-modal>
  </div>
</div>